import {ReducerState} from "./../../reducer/interface/baseInterface"
import {useSelector} from "react-redux"

export function UseModel() {
    return useSelector((state: ReducerState) => state.global.model)
}

export function UseFileInfo() {
    const useNewBase = () => {
        return useSelector((state: ReducerState) => state.file.new.baseInfo)
    }
    const useNewCompare = () => {
        return useSelector((state: ReducerState) => state.file.new.compareInfo)
    }
    const useLastBase = () => {
        return useSelector((state: ReducerState) => state.file.last.baseInfo)
    }
    const useLastCompare = () => {
        return useSelector((state: ReducerState) => state.file.last.compareInfo)
    }
    const useDisplayBase = () => {
        return useSelector((state: ReducerState) => state.file.display.baseInfo)
    }
    const useDisplayCompare = () => {
        return useSelector((state: ReducerState) => state.file.display.compareInfo)
    }
    return {
        useNewBase,
        useNewCompare,
        useLastBase,
        useLastCompare,
        useDisplayBase,
        useDisplayCompare,
    }
}

export function UseImageList() {
    const useBase = () => {
        return useSelector((state: ReducerState) => state.data.imageList.baseList)
    }
    const useCompare = () => {
        return useSelector((state: ReducerState) => state.data.imageList.compareList)
    }
    return {
        useBase,
        useCompare,
    }
}

export function UseCanvasData() {
    const useBase = () => {
        return useSelector((state: ReducerState) => state.data.canvasData.baseData)
    }
    const useCompare = () => {
        return useSelector((state: ReducerState) => state.data.canvasData.compareData)
    }
    return {
        useBase,
        useCompare,
    }
}

export function UseListData() {
    return useSelector((state: ReducerState) => state.data.listData)
}
